import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Swiper from 'react-id-swiper';
import { injectIntl, intlShape } from 'react-intl';
import { commonMessages } from '../../../messages/commonMessages';
import 'swiper/swiper-bundle.css';

import { media } from '../../../styles/style-utils';

const Wrapper = styled.div`
  position: relative;
  margin-top: ${props => (props.hideArrows ? 0 : 'var(--default-horizontal-padding)')};

  .swiper-container {
    margin-left: var(--default-horizontal-padding);
  }

  .swiper-wrapper {
    margin-bottom: var(--fr);
  }

  .swiper-slide {
    width: unset;
    height: auto;
  }

  .swiper-button-disabled {
    opacity: 0.2;
    cursor: default;
  }

  .swiper-prev,
  .swiper-next,
  .swiper-prev:hover,
  .swiper-next:hover {
    display: none;

    ${media.large`
      display: block;
      z-index: 1;
      background-color: transparent;
      border: 1px solid var(--c-white);
      width: 50px;
      height: 50px;
      padding: 15px;
    `}
  }

  .swiper-prev,
  .swiper-prev:hover {
    left: calc(50% - 55px);
    top: calc(-0.75 * var(--default-horizontal-padding));
    position: absolute;
  }

  .swiper-next,
  .swiper-next:hover {
    left: calc(50% + 5px);
    position: absolute;
    top: calc(-0.75 * var(--default-horizontal-padding));
  }

  .swiper-pagination-bullets {
    position: unset;
    margin-bottom: var(--fr);
    margin-left: 0;
    margin-right: var(--default-horizontal-padding);
  }

  .swiper-pagination-bullet {
    background: var(--c-white);
    transition: opacity 0.3s;
    margin: 0 calc(0.5 * var(--fr));
  }

  .swiper-pagination-bullet-active,
  .swiper-pagination-bullet:hover {
    opacity: 1;
  }
`;

class Carousel extends React.Component {
  renderNextButton() {
    return (
      <button
        className="swiper-next"
        aria-label={this.props.intl.formatMessage(commonMessages.nextSlide)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="white"
        >
          <path d="M6.2 1L4.8 2.5l7.4 7.5-7.4 7.5L6.2 19l9-9z" />
        </svg>
      </button>
    );
  }

  renderPrevButton() {
    return (
      <button
        className="swiper-prev"
        aria-label={this.props.intl.formatMessage(commonMessages.prevSlide)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="white"
        >
          <path d="M4.8 10l9 9 1.4-1.5L7.8 10l7.4-7.5L13.8 1z" />
        </svg>
      </button>
    );
  }

  render() {
    const { isMobile } = this.context;
    const { freeMode, children, hideArrows } = this.props;

    const params = {
      mousewheel: {
        forceToAxis: true,
        invert: true,
      },
      freeMode: freeMode || !isMobile,
      slidesPerView: 'auto',
      spaceBetween: 30,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: hideArrows ? null : '.swiper-next',
        prevEl: hideArrows ? null : '.swiper-prev',
      },
      renderPrevButton: this.renderPrevButton.bind(this),
      renderNextButton: this.renderNextButton.bind(this),
      keyboard: true,
    };

    return (
      <Wrapper hideArrows={hideArrows}>
        <Swiper {...params}>{children}</Swiper>
      </Wrapper>
    );
  }
}

Carousel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  intl: intlShape.isRequired,
  hideArrows: PropTypes.bool,
  freeMode: PropTypes.bool,
};

Carousel.contextTypes = {
  isMobile: PropTypes.bool,
};

export default injectIntl(Carousel);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/carousel/Carousel.js